import { useState } from "react";
import { Menu, X, Gamepad2, Rocket, Volume2, VolumeX } from "lucide-react";
import { gameSounds } from "@/lib/gameSounds";
import { Link } from "react-router-dom";
import StakeSoonButton from "./StakeSoon";

const LINKS = [
  { href: "#about", label: "About" },
  { href: "#tokenomics", label: "Tokenomics" },
  { href: "#how-to-buy", label: "How to Buy" },
  { href: "#roadmap", label: "Roadmap" },
  { href: "#faq", label: "FAQ" },
];

const MASCOT = "/game/logo-neon.jpg";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [muted, setMuted] = useState(gameSounds.muted);
  const toggleMute = () => {
    const m = !muted;
    gameSounds.setMuted(m);
    setMuted(m);
  };

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#05050A]/90 border-b border-[rgba(0,229,255,0.25)]"
      data-testid="navbar"
    >
      <div className="mx-auto max-w-6xl px-4 md:px-8 py-3 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5" data-testid="logo-link">
          <span
            className="logo-anim inline-block w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden border border-[rgba(0,229,255,0.5)]"
            style={{ boxShadow: "0 0 14px rgba(0,229,255,0.35)" }}
          >
            <img src={MASCOT} alt="JetDog mascot" className="w-full h-full object-cover" />
          </span>
          <span className="logo-text-shine font-display font-bold text-2xl md:text-3xl tracking-wide">JETDOG</span>
        </a>

        <nav className="hidden md:flex items-center gap-4" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-display text-xs uppercase whitespace-nowrap text-[var(--jd-ocean)] hover:text-[var(--jd-primary)] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://pump.fun/8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump"
          target="_blank"
          rel="noreferrer"
          className="gg-navbtn gg-navbtn--buy"
          data-testid="nav-buy-button"
        >
          <Rocket size={14} /> Buy $JETDOG
        </a>

        <Link
          to="/play"
          className="gg-navbtn"
          data-testid="nav-play-button"
        >
          <Gamepad2 size={14} /> Play & Earn
        </Link>

        <StakeSoonButton
          className="gg-navbtn gg-navbtn--pink"
          iconSize={14}
          testid="nav-stake-button"
        />

        <button
          type="button"
          onClick={toggleMute}
          className="gg-terminal rounded-xl p-2 text-[var(--jd-primary)] hover:scale-105 transition-transform"
          aria-label={muted ? "Unmute site sounds" : "Mute site sounds"}
          data-testid="site-mute-toggle"
        >
          {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
        </button>

        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden gg-terminal rounded-xl p-2 text-[var(--jd-primary)]"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[rgba(0,229,255,0.25)] bg-[#07070E]" data-testid="mobile-nav">
          <div className="px-4 py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-display text-lg uppercase text-[var(--jd-text)] hover:text-[var(--jd-primary)]"
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://pump.fun/8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump"
              target="_blank"
              rel="noreferrer"
              className="nb-btn nb-btn--cyan mt-2"
              data-testid="mobile-buy-button"
            >
              Buy $JETDOG
            </a>
            <Link
              to="/play"
              onClick={() => setOpen(false)}
              className="nb-btn"
              data-testid="mobile-play-button"
            >
              <Gamepad2 size={18} /> Play & Earn
            </Link>
            <StakeSoonButton
              className="nb-btn nb-btn--accent"
              testid="mobile-stake-button"
              onOpen={() => setOpen(false)}
            />
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
